module.exports = __webpack_public_path__ + "static/media/pay-it-forward.b9e45e7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pay-it-forward.svg
// module id = 168
// module chunks = 0